// QuotesModel.jsx
const QuotesModel = {
  getQuotes: () => [
    "Art as a starter or a dessert?",
    "I've heard about a beauty that I can't seem to find",
    "You need a miracle baby, but I wouldn't wait too long",
    "First they laugh, then they copy",
    "So, what do you feel?",
    "Seen any miracles lately? They hardly ever come along",
    "Think again",
    "What if?",
    "Ideally, this text was meant to be read tomorrow",
    "Tomorrow is closed",
    "Erotic inferno",
    "Infinite hues of blue and grey",
    "No one will give you a wake up call",
    "Cover our eyes, it feels so nice",
    "Say the wrong things the right way",
    "We're all reaching out to find another hand",
    "I think they got it all wrong",
    "I owe it to you",
    "Interlinking",
    "Thought I would hear a sermon in the furthest part of town",
    "What was the last time you felt inspired?",
    "Do you know who you are?",
    "Do you have high expectations?",
    "That's just the weight of the world",
    "Hearing melancholy moans in the distance",
    "Nobly knelt before us",
    "Welcome to the jungle",
    "You got to close your eyes to see",
    "The guy said I was a heathen, it was weighing me down",
    "Not mad about the judgement you are offering me",
    "Burning through the breaks",
    "One part evil, three fifths blind",
    "Gaze upon the ember eye",
    "Exile from your garden",
    "But maybe one day soon it will come to you",
    "Never ending moment",
    "This is a love song",
    "All I wanna do is make you melt",
    "I can see the look in your eyes",
    "Taking your warm embrace",
    "Stand and listen to the train go by",
    "Sorry, this is members only",
    "Borderlines are drawn because of where you're born",
    "Don't you dare protest",
    "Some people fear the end but I carry it in my pocket",
    "I'm just a broken machine",
    "Though the record may spin all my lights have gone dim",
    "My head goes forward and my heart goes back",
    "I'm a mechanical thing, Nothing bothers me now.",
    "Now we start to dream",
    "Out of the city tonight?",
    "Where do you float to when you return to dust?",
    "Will it flow into the river?",
    "Before we drift away",
    "Each had a half of a king and queen seat",
    "No one told you when to run",
    "You missed the starting gun",
    "Summer was long and it's suffocating when you're alone",
    "But you know me too well",
    "Do you wanna free your body tonight?",
    "Is this familiar to you?",
    "A clock without a face",
    "Can you afford to be an individual?",
    "Our thoughts are tribal",
    "Are you scared of your introspection?",
    "Prisoner of your own illusion",
    "In your own echo chamber",
    "You are a walking contradiction",
    "How can you hate something you don't even understand?",
    "Who to love and who to not?",
    "No second chances, you're branded, you're kind of dangerous",
    "We're bringing each other down",
    "This feels like the end",
    "We devolve into inferior beings",
    "There is a tension in the air",
    "It's in our homes, our chlorinated chicken",
    "Stare at whatever clickbait debate next goes viral",
    "Your consent is manufactured",
    "Five star hotel, I don't feel well",
    "I lost a night or maybe two",
    "I think I'll cancel the honeymoon",
    "Crossed the line a life ago",
    "Fat cat hotel, I don't feel well",
    "I lost the plot or maybe two",
    "Moral panic is setting in",
    "Let's go blur the line",
    "We've met your kind before, set fire to us all",
    "I will look after you",
    "Welcome to the infinite black skies",
    "Fragments and scattered debris",
    "You've been bitten by someone who's hungrier than you",
    "You've been bitten by someone's false beliefs",
    "Take the next ticket",
    "Maybe you were ready all along",
    "I wanna talk about Ireland",
    "No need for metaphors",
    "You're on the borderline",
    "Here comes the sun",
    "I can hear an alarm",
    "If only you could see it",
    "Layers of dust and yesterdays",
    "One woman whistling a wounded lullaby",
    "The last man standing in our sinister charade",
    "And we'll all be the weak and the weary sometime",
    "You caught me in the moonlight",
    "Filthy impetuous soul",
    "Imaginations running wild",
    "What a day",
    "I could swear I was on the list",
    "This is performative",
    "Why don't you come inside and pull up a chair?",
    "Scrolling through a life I barely recognised",
    "No turning back",
    "Shake of the darkness and harness the light",
    "Dark necessities are part of the design",
    "Find your coat and make your way outside",
    "Slip into the naked night",
    "Touched your gaze or even saw your soul",
    "Maybe you were",
    "What you are is almost gone",
    "On perd de l'altitude, toi et moi",
    "J'vais avoir l'habitude mais ces derniers mois j'ai flanché",
    "Même si j'y perds ma liberté, vouloir trop réussir, la pression du succès",
    "Shadows grow long",
    "I'm here in front of you",
    "But never for money",
    "I watch you glow",
    "Pop the balloon",
    "Create chaos by design",
    "We're gonna shed off the weight and watch it all float away",
    "I'll do it for you",
    "Reflect the sun",
    "Would you like a souvenir?",
    "The engine has failed again",
    "Do you love me yet?",
    "Pick up the award for Best Dropped Act",
    "Apart from that, how do you feel?",
    "Headlights closing in",
    "We paint our faces keep the truth deep under cover",
    "We gather round the fire and tell lies to each other",
    "So desperate to feel like we're not getting older now",
    "Spray paint the galleries and spill blood on the altar",
    "Burn down the bridges that we could have crossed together",
    "This ground floor vertigo threatens to pull me under now",
    "We lost the love of life on the way",
    "We wear this war paint to forget what we've discovered",
    "Rather be mirror blind and safe under our armour",
    "Let's free each other from this modern day inertia now",
    "Full of all possibilities",
    "From tonight to infinity",
    "Raise your glass to eternity",
    "It's you and me",
    "Something bright amid the black",
    "Staring at the sun heeds warning from mankind",
    "Recite our verses poems for the dead",
    "Echoes fade",
    "Dokunuyor zaman",
    "Eve gitmem gerek, her yerdeyim",
    "I've been havin' dreams",
    "I've been overseas",
    "All I see is green",
    "Open up the door for me",
    "Como una promesa que nunca se cumple",
    "Instantes que no pueden volver",
    "El recuerdo es un veneno dulce",
    "Tu amor es mi cábala",
    "Viene a partirme la cara su ráfaga",
    "Aviva la llama del gran chamán",
    "Se nos va la vida deseando otra",
    "Look around, there's no one else left",
    "All the heart beats in its cage",
    "I guess I'll go",
    "I was waiting for you",
    "What did take you so long?",
    "From the green and lovely lanes of Killeshandra",
    "Ifrite alevler koymaz",
    "I politely decline",
    "It never ends",
    "You've been my muse for a long time"
  ],
};

export default QuotesModel;
